import { create } from "zustand";

export const createWishlistSlice = create((set) => ({
  wishlist: [],
  addToWishlist: (product) =>
    set((state) => {
      const existingProduct = state.wishlist.find((p) => p._id === product._id);
      if (existingProduct) {
        return {
          wishlist: state.wishlist.map((p) => 
            p._id === product._id ? { ...p, isInWishlist: true } : p
          ),
        };
      }
      return { wishlist: [...state.wishlist, { ...product, isInWishlist: true }] };
    }),
  removeFromWishlist: (productId) =>
    set((state) => {
      return {
        wishlist: state.wishlist.filter((product) => product._id !== productId),
      };
    }),
  clearWishlist: () => set({ wishlist: [] }),
}));


export const useWishlistStore = createWishlistSlice;
